import * as ActiveStorage from "@rails/activestorage";
import "@rails/actiontext";
import Rails from "@rails/ujs";
import {createRoot} from "react-dom/client";
import "whatwg-fetch";
import Application from "components/application";
import "lib/trix";
import "app/assets/style.external.scss";
import "app/assets/style.scss";

Rails.start();
ActiveStorage.start();

document.addEventListener("DOMContentLoaded", () => {
  const node = document.querySelector("#app");
  const props = JSON.parse(node.getAttribute("data"));
  const root = createRoot(node);

  root.render(<Application {...props} />);
});
